module.exports = __webpack_public_path__ + "static/media/q.48ad9f9e.svg";